import { all, call, put, select, takeLatest } from "redux-saga/effects";

import {
  getListEmployeeLeaveRequestStart,
  getListEmployeeLeaveRequestSuccess,
  getListEmployeeLeaveRequestFailed,
} from "../redux/getListEmployeeLeaveRequest";

import { controlInfinitiveScrollSelector } from "components/common/ListInfinitiveScrolling/redux/selector";
import { formFilterEmployeeLeaveSelector } from "../redux/selector";
import { getEmployeeLeaveRequestApi } from "core/http/service/employeeRequest";
import { typeScrollEmployeeRequest } from "./exportEmployeeRequest";
import { declareLeaveURL } from "../Pages/Main/DeclareLeaveContent";

function* getListEmployeeLeaveRequestWork() {
  const { offset, limit } = yield select(
    controlInfinitiveScrollSelector(
      typeScrollEmployeeRequest[declareLeaveURL.leave]
    )
  );
  const { from, to, ...rest } = yield select(formFilterEmployeeLeaveSelector);

  const params = {
    offset,
    limit,
    ...rest,
    fromMonth: from?.month() + 1,
    fromYear: from?.year(),
    toYear: to?.year(),
    toMonth: to?.month() + 1,
  };
  try {
    const res = yield call(getEmployeeLeaveRequestApi, params);
    yield put({
      type: getListEmployeeLeaveRequestSuccess.type,
      payload: {
        data: res.data,
        categoryName: res.categoryName,
        totalRecords: res.totalRecords,
      },
    });
  } catch (error: any) {
    yield put({
      type: getListEmployeeLeaveRequestFailed.type,
    });
  }
}

function* watchGetListEmployeeLeaveRequest() {
  yield takeLatest(
    getListEmployeeLeaveRequestStart.type,
    getListEmployeeLeaveRequestWork
  );
}

export default function* getListEmployeeLeaveRequestSaga() {
  yield all([watchGetListEmployeeLeaveRequest()]);
}
